import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/paymentByLoyaltyPoints', request)
}

export {get}
